import React from 'react';
import ErrorPage from '../../components/ErrorPage';

function ServerError() {
  return (
    <ErrorPage
      code="500"
      title="服务器错误"
      message="服务暂时不可用，请稍后重试。若问题持续，请联系管理员。"
    />
  );
}

export default ServerError;
